import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="mt-auto w-full bg-secondary-900 text-secondary-50">
      <div className="w-full px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-tv-2-line text-xl"></i>
              </span>
              <span className="font-heading text-xl font-700 text-background-50">
                韩剧<span className="text-primary-300">TV</span>
              </span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-secondary-200">
              韩剧TV 专注提供最新韩剧资讯与剧集推荐，涵盖热门韩剧介绍、剧情解析与观看指南，帮助每一位韩剧爱好者快速找到想看的内容。
            </p>
            <p className="mt-4 text-xs text-secondary-400">
              本站内容均为虚构示例演示数据，仅用于产品展示，不含任何真实版权信息。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-600 text-background-50">
              <Link to="/category/news" className="cursor-pointer hover:text-primary-300">
                站内导航
              </Link>
            </h4>
            <ul className="mt-4 space-y-3 text-sm">
              <li><Link to="/category/news" className="cursor-pointer text-secondary-200 hover:text-primary-300">韩剧资讯</Link></li>
              <li><Link to="/category/drama" className="cursor-pointer text-secondary-200 hover:text-primary-300">剧集大全</Link></li>
              <li><Link to="/specials" className="cursor-pointer text-secondary-200 hover:text-primary-300">专题合集</Link></li>
              <li><Link to="/about" className="cursor-pointer text-secondary-200 hover:text-primary-300">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-600 text-background-50">联系我们</h4>
            <ul className="mt-4 space-y-3 text-sm text-secondary-200">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-base"></i>
                hello@hanju-tv.example.com
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-base"></i>
                内容每日更新
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-map-pin-line text-base"></i>
                首尔 · 上海 · 线上
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-secondary-700/60 pt-6 text-xs text-secondary-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2025 韩剧TV · 最新韩剧在线资讯与剧集推荐</p>
          <p className="flex flex-wrap gap-4">
            <Link to="/about" className="cursor-pointer hover:text-primary-300">版权声明</Link>
            <Link to="/about" className="cursor-pointer hover:text-primary-300">使用须知</Link>
            <Link to="/about" className="cursor-pointer hover:text-primary-300">联系方式</Link>
          </p>
        </div>
      </div>
    </footer>
  );
}